import React from "react";
import {ToolbarButton, useGridApiContext} from "@mui/x-data-grid";
import type {GridDensity} from "@mui/x-data-grid-premium";
import {gridDensitySelector, useGridSelector} from "@mui/x-data-grid-premium";
import {ListItemIcon, ListItemText, Menu, MenuItem, Tooltip} from "@mui/material";
import {Check, DensityMedium} from "@mui/icons-material";

const DENSITIES: {value: GridDensity, label: string}[] = [
    {value: 'compact', label: 'Compact'},
    {value: 'standard', label: 'Standard'},
    {value: 'comfortable', label: 'Comfortable'},
];

/**
 * Row density menu for the grid toolbar.
 */
export const GridDensityButton: React.FC = () => {
    const apiRef = useGridApiContext();
    const [anchor, setAnchor] = React.useState<HTMLElement | null>(null);
    const density = useGridSelector(apiRef, gridDensitySelector);

    return <>
        <Tooltip title="Row density">
            <ToolbarButton color="primary" aria-label="Row density" onClick={e => setAnchor(e.currentTarget)}>
                <DensityMedium fontSize="small"/>
            </ToolbarButton>
        </Tooltip>
        <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
            {DENSITIES.map(d => <MenuItem key={d.value} onClick={() => {
                apiRef.current?.setDensity(d.value);
                setAnchor(null);
            }}>
                <ListItemIcon>{density === d.value && <Check fontSize="small"/>}</ListItemIcon>
                <ListItemText>{d.label}</ListItemText>
            </MenuItem>)}
        </Menu>
    </>;
};
